import { useEffect } from 'react';

const TOKEN_KEY = 'access_token';
const USER_DATA_KEY = 'userData';

// The token arrives in the URL fragment, which browsers never send to the server.
// It is read once when the bundle loads, removed from the address bar, then stored
// exactly as a normal login would store it.
const handoff = (() => {
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    return { access: params.get('access'), next: params.get('next') || '/' };
})();

const safePath = (path) => (path.startsWith('/') && !path.startsWith('//') ? path : '/');

const Handoff = () => {
    useEffect(() => {
        window.history.replaceState(null, '', window.location.pathname);
        const finish = () => window.location.replace(safePath(handoff.next));
        if (!handoff.access) {
            finish();
            return;
        }
        localStorage.setItem(TOKEN_KEY, handoff.access);
        // The app only trusts a stored session that also has the user profile.
        fetch('/api/users/me/', { headers: { Authorization: `Bearer ${handoff.access}` } })
            .then((res) => (res.ok ? res.json() : null))
            .then((user) => {
                if (user) localStorage.setItem(USER_DATA_KEY, JSON.stringify(user));
            })
            .finally(finish);
    }, []);

    return null;
};

export default Handoff;
